import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Heading } from "@americanexpress/dls-react";
import FormField from "../../Common/FormField";
import PABirthDetails from "./PABirthDetails";
import Upload from "../../Import/Upload";
import { COUNTRIES_WITH_CITY_FIELD } from "../../Common/constants";
import { getPAScreeningCountries, getPersonalIdHelperTextKey } from "../../Common/utils";

const PAScreeningSection = ({ formik, isModifyUser, country }) => {
  const { t } = useTranslation("common");
  const isPersonalIdEntered = !!formik.values.personalIdNumber;
  const isSwedenNorway = COUNTRIES_WITH_CITY_FIELD(t).includes(country);
  const isIEC = country === t(`access.INTERNATIONALEUROCARD`);

  const isPersonalIdRequired = () => {
    const { values } = formik;
    return (
      !values.day &&
      !values.month &&
      !values.year &&
      !values.nationality &&
      !values.cityOfBirth &&
      !values.countryOfBirth
    );
  };

  const handlePersonalIdRequirement = () => {
    if (isPersonalIdRequired() && formik.touched.personalIdNumber) {
      return formik.errors.personalIdNumber;
    }
    return null;
  };

  const personalIdHelperTextKey = getPersonalIdHelperTextKey(country, t);

  return (
    <section id="pa-screening">
      <div className="row">
        <div className="col-xs-12">
          <Heading
            level={4}
            className="heading-4 dls-deep-blue pad-2-t pad-2-b"
          >
            {isModifyUser
              ? t("newUserUK.modifyPAInfoForScreening")
              : t("newUserUK.newPAInfoForScreening")}
          </Heading>
        </div>
      </div>
        {personalIdHelperTextKey && (
            <div className="row">
                <div className="col-xs-12 pad-2-b">
                    <p>{t(personalIdHelperTextKey)}</p>
                </div>
            </div>
        )}
      {isSwedenNorway && (
        <div className="row">
          <FormField
            id="personalIdNumber"
            name="personalIdNumber"
            label={t("newuser.personalIdNumber")}
            placeholder="YYMMDD-NNNNN"
            colmd="col-md-3"
            value={formik.values.personalIdNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={handlePersonalIdRequirement()}
          />
        </div>
      )}
      <div className="row">
        <FormField
          id="day"
          name="day"
          label={t("newuser.day")}
          placeholder={t("common.dd")}
          value={formik.values.day}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          maxLength="2"
          colmd="col-md-3"
          error={
            !isPersonalIdEntered && formik.touched.day && formik.errors.day
          }
        />
        <FormField
          id="month"
          name="month"
          label={t("newuser.month")}
          maxLength="2"
          colmd="col-md-3"
          placeholder={t("common.mm")}
          value={formik.values.month}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            !isPersonalIdEntered && formik.touched.month && formik.errors.month
          }
        />
        <FormField
          id="year"
          name="year"
          label={t("newuser.year")}
          placeholder={t("common.yyyy")}
          maxLength="4"
          colmd="col-md-3"
          value={formik.values.year}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            !isPersonalIdEntered && formik.touched.year && formik.errors.year
          }
        />
        <FormField
          id="nationality"
          name="nationality"
          label={t("newuser.nationality")}
          colmd="col-md-3"
          value={formik.values.nationality}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            !isPersonalIdEntered &&
            formik.touched.nationality &&
            formik.errors.nationality
          }
        />
      </div>
      {isIEC && (
        <div className="row">
          <FormField
            id="motherMaidenName"
            name="motherMaidenName"
            label={t("newuser.motherMaidenName")}
            colmd="col-md-3"
            value={formik.values.motherMaidenName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.motherMaidenName && formik.errors.motherMaidenName
            }
          />
        </div>
      )}
      {COUNTRIES_WITH_CITY_FIELD(t).includes(country) && (
        <PABirthDetails formik={formik} country={country} />
      )}
      <hr />
      {!isIEC && getPAScreeningCountries(t).includes(country) && (
        <>
          <Upload
            isModifyUser={isSwedenNorway && isModifyUser}
            country={country}
            getFile={(files) => {
              formik.setFieldValue("paScreeningFiles", [...(files || [])], true);
              formik.setFieldTouched("paScreeningFiles", true, false);
            }}
            files={formik.values.paScreeningFiles || []}
          />
          {!isModifyUser &&
            formik.touched.paScreeningFiles &&
            formik.errors.paScreeningFiles &&
            formik.values.paScreeningFiles?.length === 0 && (
              <Alert status="error">{t("access.uploaderror")}</Alert>
            )}
          {isModifyUser && isSwedenNorway && (
            <div className="dls-red margin-2-b margin-1-l">
              {t("access.uploadsupportdocmessage")}
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default PAScreeningSection;
